import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconPerformance } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleNkfMediaStats } from '../../actions';
import { isNkfMediaStatsOpen } from '../../functions';
/**
 * Toolbar item that shows/hides the "メディア計測" panel: main-thread pressure
 * next to the transmitted-audio dropout rate.
 *
 * The two belong on screen together — a main-thread stall longer than the emit
 * queue (~96 ms) is what punches holes in the sent audio, so watching one
 * without the other explains nothing.
 */
class NkfMediaStatsButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityNkfMediaStats';
    icon = IconPerformance;
    label = 'toolbar.nkfMediaStats';
    toggledLabel = 'toolbar.nkfMediaStatsOff';
    tooltip = 'toolbar.nkfMediaStats';
    /**
     * Toggles the media stats panel.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _open, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('nkf.mediastats', { enable: !_open }));
        dispatch(toggleNkfMediaStats());
    }
    /**
     * Toggled (ON) while the panel is visible.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._open;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _open: isNkfMediaStatsOpen(state)
    };
}
export default translate(connect(mapStateToProps)(NkfMediaStatsButton));
